

<div class="modal-header">
    <h4
        class="modal-title"
        id="modal-title"
    >Change Container Status</h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Close button"
        aria-describedby="modal-title"
        (click)="activeModal.dismiss('Cross click')"
    ></button>
</div>
<form [formGroup]="changeStatusForm">
    <div class="modal-body">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Job Type</th>
                    <th>Containers #</th>
                    <th>Current Status</th>
                    <th>Applicable Status</th>
                </tr>
            </thead>
            <tbody formArrayName="containerGroups">
                @for(group of containerGroups.controls; track $index){
                    @let groupIndex = $index;
                    <tr [formGroupName]="groupIndex">
                        <td>
                            {{ containerStatusGroups[groupIndex]?.jobType }}
                        </td>
                        <td>
                            @for(containerNumber of containerStatusGroups[groupIndex]?.containerNumbers; track $index){
                            <dl class="m-b-xs">
                                {{ containerNumber }}
                            </dl>
                            }
                        </td>
                        <td>
                            {{ containerStatusGroups[groupIndex]?.currentStatus }}
                        </td>
                        <td>
                            <!-- Applicable Status -->
                            <ng-select
                                formControlName="applicableStatus"
                                [items]="containerStatusGroups[groupIndex]?.applicableStatusList"
                                bindLabel="name"
                                placeholder="Select Status"
                            >
                            </ng-select>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-mogo btn-primary"
            (click)="onSubmit()"
            [disabled]="changeStatusForm.invalid"
        >Submit</button>
        <button
            type="button"
            class="btn btn-default"
            (click)="activeModal.dismiss(false)"
        >Close</button>
    </div>
</form>
